<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm10 md6 lg5 xl4>
        <v-card tile>
          <v-toolbar dark dense flat color="primary">
            <v-toolbar-title>云南省工业和信息化厅项目管理系统-登录</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip right>
              <v-btn
                icon
                large
                href="#"
                target="_blank"
                slot="activator"
              >
                <v-icon large>help_outline</v-icon>
              </v-btn>
              <span>需要帮助？</span>
            </v-tooltip>
          </v-toolbar>
          <v-progress-linear class="my-0" :indeterminate="true" v-if="loginLoading" :active="loginLoading" height="2"
                             color="orange"/>

          <v-alert
            type="error"
            :value="showMessage"
            style="margin: 0;border-color: transparent !important;"
          >
            {{ message }}
          </v-alert>
          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0">
                <v-card-text>
                  <v-form>
                    <v-text-field
                      :disabled="loginLoading"
                      prepend-icon="person"
                      v-model="userDeptRole.username"
                      name="username"
                      label="统一社会信用代码/电子邮箱/用户名"
                      :rules="rules.username"
                      id="username"
                      type="text"/>

                    <v-text-field
                      :disabled="loginLoading"
                      prepend-icon="lock"
                      v-model="userDeptRole.password"
                      name="password"
                      label="密码"
                      id="password"
                      type="password"
                      @keyup.enter="onLogin"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" flat @click="$router.push('/register')" :disabled="loginLoading">注册新用户
                  </v-btn>
                  <v-btn color="primary" flat to="/forget">找回密码？</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.native.stop="onLogin" :disabled="loginLoading">
                    {{ loginLoading ? '正在登录' : '登录' }}
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0">
                <v-card-text>
                  <v-form>
                    <v-subheader>请选择部门和角色</v-subheader>
                    <v-radio-group
                      v-model="userDeptRoleSel"
                      @change="onDeptRoleChange"
                      class="pt-0 pl-3"
                    >
                      <v-radio
                        v-for="udr in userDeptRoleItems"
                        :key="`${udr.deptId}-${udr.roleId}`"
                        :label="`${udr.deptName}[${udr.roleName}]`"
                        :value="udr"
                      />
                    </v-radio-group>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="doLogin" :disabled="loginLoading">
                    {{ loginLoading ? '正在登录' : '确定' }}
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>
              <v-stepper-content step="3" class="pa-0">
                <v-card-text>
                  <v-form>
                    <v-subheader>请选择要登录的企业</v-subheader>
                    <v-radio-group
                      v-model="enterSel"
                      @change="onEnterChange"
                      class="pt-0 pl-3"
                    >
                      <v-radio
                        v-for="enter in enterItems"
                        :key="`${enter.username}-${enter.deptId}-${enter.roleId}`"
                        :label="`${enter.deptName}`"
                        :value="enter"
                      />
                    </v-radio-group>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="onLogin" :disabled="loginLoading">
                    {{ loginLoading ? '正在登录' : '确定' }}
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
        <!--        <v-card-->
        <!--          href="http://pingxuan.ynetc.gov.cn"-->
        <!--        >-->
        <!--          <v-card class="mt-3">-->
        <!--            <v-card-media-->
        <!--              height="120px"-->
        <!--              src="/static/pingxuan.jpg"-->
        <!--            >-->
        <!--            </v-card-media>-->
        <!--          </v-card>-->
        <!--        </v-card>-->
        <v-card class="mt-3">
          <!--<v-card-title class="subheading light-blue">说明</v-card-title>-->
          <!--<v-divider></v-divider>-->
          <v-card-text class="py-2 px-4">
            <!--            <p style="color: red">-->
            <!--              通知：从2022年1月1日起，云南省工业和信息化厅项目管理系统的网址将变更为 <a href="http://220.163.9.134/">http://220.163.9.134/</a>,请相关部门和相关企业提前收藏该网址，确保工作顺利开展。-->
            <!--            </p>-->
            <p style="color: red">
              通知：<br/>
              从2022年1月1日起，云南省工业和信息化厅项目管理系统的网址将变更为 <a href="http://220.163.9.134/">http://220.163.9.134/</a>,请相关部门和相关企业收藏该网址，确保工作顺利开展。<br/>
              <!--              2.2022年省级中小企业发展专项资金网络申报已全面开通，请各申报单位按照指南要求及时完成网络申报，申报政策相关问题请联系县区、州市工信部门，或按照各方向申报指南联系省工信厅相关处室咨询。<br/>-->
            </p>
          </v-card-text>
          <v-card-text class="py-2 px-4">
            <p>
              <!--说明:<br/>-->
              <!--本系统目前可申报专项资金包括以下几类：<br/>-->
              <!--<span class="text&#45;&#45;primary">1. 2018年省级工业转型升级（中国制造2025）专项资金</span><br/>-->
              <!--<span class="text&#45;&#45;primary">2. 2018年云南省中药饮片产业发展专项资金。</span><br/>-->
              <!--<span class="text&#45;&#45;primary">3. 2018年省级工业和信息化发展专项资金(技术改造方向)。</span><br/>-->
              <!--<span class="text&#45;&#45;primary">4. 2018年省级工业和信息化发展专项资金园区项目。</span><br/>-->
              <!--其余方向专项资金申报入口将陆续开通，可先行注册填报企业和项目信息。-->
              <!--<br/>-->
              <!--<br/>-->
              <!--技术支持 ：<a href="http://www.ynmaker.com">云南唯恒基业科技有限公司</a> 咨询电话：18088138909-->
              技术支持 ：<a href="http://www.ynmaker.com">云南唯恒基业科技有限公司</a>
              <br/>
              <!--              咨询电话 ：18088138909、18213714265、17358459328、13888327451-->
              咨询电话 ：18213714265、17358459328、13888327451
              <br/>
              服务时间 ：工作日 上午8:00-12:00，下午14:00-17:00
            </p>
          </v-card-text>
        </v-card>

        <yes-no-msg-box
          v-model="showMsg"
          :message="mainMessage"
          :titleMessage="titleMessage"
          :onlyOk="true"
          v-on:ok="msgOk"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import print from "vue-print-nb";
import YesNoMsgBox from "@/components/global/YesNoMsgBox";


const loginURI = '/api/login';

export default {
  components: {YesNoMsgBox},
  data: () => ({
    loginLoading: false,
    afterLogin: null,

    userDeptRole: {
      userId: '',
      name: '',
      username: '',
      password: '',
      deptId: '',
      deptName: '',
      roleId: '',
      roleName: '',
      roleRoute: null
    },

    showMsg: false,
    mainMessage: null,
    titleMessage: null,

    userDeptRoleItems: [],
    userDeptRoleSel: {},

    enterItems:[],
    enterSel:{},

    step: 1,

    message: '',

    rules: {
      username: [
        v => !!v || '必填项。',
        v => (!v || v.trim().length === 0 || /^[@.A-Za-z0-9_-]+$/ig.test(v)) || '请输入统一社会信用代码、电子邮箱或用户名'
      ]
    }
  }),

  // 路由进入前，组件就未完成渲染，不可以使用 this
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    // console.log(to)
    next(
      vm => {
        vm.afterLogin = to.query.redirect || null;
        vm.userDeptRole = {
          userId: '',
          name: '',
          username: '',
          password: '',
          deptId: '',
          deptName: '',
          roleId: '',
          roleName: '',
          roleRoute: null
        };
        vm.userDeptRoleItems = [];
        vm.userDeptRoleSel = {};

        vm.step = 1;
        vm.message = '';
        if (to.query && to.query.token) {
          //获取用户信息
          const token = to.query.token
          let creditUri = '/api/login/ssologin'
          vm.axios.get(creditUri, {params: {token: token}})
            .then(
              rsp => {
                if (rsp.data != "" && rsp.data.success == "true") {
                  let entInfos = rsp.data.entInfos
                  if(entInfos && entInfos.length>0){
                    for (let entInfo of entInfos) {
                      entInfo.password = decodeURIComponent(window.atob(entInfo.password))
                    }
                  }
                  if (entInfos && entInfos.length == 0) {
                    vm.showMsg = true
                    vm.mainMessage = "企业未在本系统注册，请返回登录界面注册后登录！"
                    vm.titleMessage = "企业未注册！"
                  }
                  if (entInfos && entInfos.length == 1) {
                    // 直接用企业信息登录系统
                    // console.log(entInfos)
                    // console.log("直接用企业信息登录系统")
                    let entInfo = entInfos[0]
                    vm.userDeptRole.username = entInfo.username
                    vm.userDeptRole.password = entInfo.password
                    vm.onLogin()
                  }
                  if (entInfos && entInfos.length > 1) {
                    // 用户选择要登录的企业
                    vm.step = 3
                    vm.enterItems = entInfos

                    // console.log("用户选择要登录的企业")
                  }

                } else {
                  vm.showMsg = true
                  vm.mainMessage = rsp.data.msg + "请返回登录界面直接登录系统！"
                  vm.titleMessage = rsp.data.msg
                  // vm.$router.push("/login")
                }

                // if (rsp.data !== "") {
                //   let udr = rsp.data;
                //   console.log(udr);
                //   Object.assign(vm.userDeptRole, udr);
                //   this.doLogin();
                // } else {
                //   vm.loginLoading = false;
                //   vm.step = 1;
                // }
              }
            );
        }
      });
  },

  // 路由改变前，组件就已经渲染完成，可以使用 this
  beforeRouteUpdate(to, from, next) {
    console.log(from)
    console.log(to)
    this.userDeptRole = {
      userId: '',
      name: '',
      username: '',
      password: '',
      deptId: '',
      deptName: '',
      roleId: '',
      roleName: '',
      roleRoute: null
    };
    this.userDeptRoleItems = [];
    this.userDeptRoleSel = {};

    this.step = 1;
    this.message = '';

    next();
  },

  computed: {
    showMessage() {
      return this.message && this.message.length > 0;
    }
  },

  created() {
    if (this.$route.query.u) {
      this.onLoginX();
    }
  },

  methods: {
    onLogin() {
      const vm = this;
      if (vm.loginLoading === true) return;

      vm.loginLoading = true;
      //console.log("login");

      const username = this.userDeptRole.username;
      const password = this.userDeptRole.password;

      const token = xutil.token('GET', loginURI, 0, username, password, '', '');

      vm.message = '';
      // !!!Important, invalid last session
      this.$store.commit("logout");
      this.axios.get(loginURI, {headers: {'X-AUTH-TOKEN': token}})
        .then(
          rsp => {
            if (!Array.isArray(rsp.data)) {
              vm.message = rsp.data.message;
              vm.loginLoading = false;
              return;
            }

            vm.userDeptRoleItems = rsp.data.map(
              udr => {
                delete udr.password;
                return udr;
              }
            );

            // 默认先选中第一个角色
            vm.userDeptRoleSel = vm.userDeptRoleItems[0];
            Object.assign(vm.userDeptRole, vm.userDeptRoleSel);

            // 该用户只有一个部门和角色
            if (vm.userDeptRoleItems.length === 1) {
              this.doLogin();
            } else {
              vm.loginLoading = false;
              vm.step = 2;
            }
          }
        )
        .catch(ex => {
          vm.loginLoading = false;
        });
    },
    onLoginX() {
      const vm = this;
      if (vm.loginLoading === true) return;

      vm.loginLoading = true;
      //console.log("login");
      vm.message = '';
      // !!!Important, invalid last session
      this.$store.commit("logout");
      this.axios.post('/api/login/x', {"u": this.$route.query.u})
        .then(
          rsp => {
            if (rsp.data !== "") {
              let udr = rsp.data;
              console.log(udr);
              Object.assign(vm.userDeptRole, udr);
              this.doLogin();
            } else {
              vm.loginLoading = false;
              vm.step = 1;
            }
          }
        )
        .catch(_ => {
          vm.loginLoading = false;
        });
    },

    // 选择用户的部门和角色
    onDeptRoleChange(v) {
      //console.log(v);
      Object.assign(this.userDeptRole, v);
    },

    onEnterChange(v){
      // Object.assign(this.userDeptRole, v)
      // console.log(this.userDeptRole)

      // const vm = this;
      // console.log(v.username)
      this.userDeptRole.username = v.username
      this.userDeptRole.password = v.password

    },

    doLogin() {
      const vm = this;
      vm.loginLoading = true;

      this.$store.commit("login", Object.assign({}, this.userDeptRole, {deptRoles: this.userDeptRoleItems}));

      const path = this.userDeptRole.roleRoute || this.afterLogin;
      this.$router.push(
        {path: path},
        () => vm.loginLoading = false, // onComplete
        () => vm.loginLoading = false, // onAbort
      );
    },
    msgOk() {
      this.showMsg = false
      this.$router.push("/login")
    }
  }
}
</script>
<style scoped>
div.stepper__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ssoLogin.vue